import { type Ref, forwardRef } from "react";
import type { SVGProps } from "react";
const LineChartSolid = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    width={24}
    height={24}
    ref={ref}
    {...props}
  >
    <path d="M20 8.5a2.5 2.5 0 1 0-2.062-1.087l-2.571 4.114a2.52 2.52 0 0 0-1.719.37l-2.186-1.458q.038-.214.038-.439a2.5 2.5 0 1 0-4.563 1.413l-2.57 4.114a2.5 2.5 0 1 0 1.696 1.06l2.57-4.114a2.52 2.52 0 0 0 1.719-.37l2.187 1.458q-.039.214-.039.439a2.5 2.5 0 1 0 4.563-1.413l2.57-4.114q.18.027.367.027" />
  </svg>
);

const ForwardRef = forwardRef(LineChartSolid);
export default ForwardRef;
